import React, { useContext } from "react";
import {
  Table,
  Thead,
  Tr,
  Th,
  Td,
  Checkbox,
  Skeleton,
  Tbody,
  Box,
  Flex,
} from "@chakra-ui/react";
import { getOrderStatusBadge } from "../../Utils/utils";
import { useHistory, useParams } from "react-router-dom";
import { FaRegEdit } from "react-icons/fa";
import { OrdersContext } from "../Context/OrdersContext";
import moment from "moment";
import TdType from "../Common/Table/TdType";
import { numberFormatter } from "../../Utils/formatUtils";
import CustomTBody from "../Common/Table/CustomTBody";
import Pagination from "../Common/Layout/Pagination";

const OrdersTable = () => {
  const {
    orders,
    maxPagination,
    currentPage,
    setSelectedOrders,
    selectedOrders,
    isLoadingOrders,
    setPagination,
  } = useContext(OrdersContext);
  const history = useHistory();
  moment.locale();
  let params = useParams().state;

  const handleCheckbox = (value, order) => {
    value.target.checked ? addSelectedOrder(order) : removeSelectedOrder(order);
  };

  const addSelectedOrder = (order) => {
    setSelectedOrders([...selectedOrders, order]);
  };
  const removeSelectedOrder = (order) => {
    const newSelectedOrderList = selectedOrders.filter(
      (item) => item.id !== order.id
    );
    setSelectedOrders(newSelectedOrderList);
  };

  const isChecked = (order) => {
    if (selectedOrders.find((selectedOrder) => selectedOrder.id === order.id)) {
      return true;
    }
    return false;
  };

  const handleSelectedPage = (page) => {
    setPagination(page);
  };

  const createRows = () => {
    let formattedRows = orders.map((order) => {
      return [
        {
          item: (
            <Checkbox
              borderColor={"menu.600"}
              onChange={(value) => {
                handleCheckbox(value, order);
              }}
              isChecked={isChecked(order)}
            />
          ),
        },
        {
          item: <TdType text={order.id} />,
        },
        {
          item: (
            <TdType text={order.businessName + " (" + order.userId + ")"} />
          ),
        },
        {
          item: <TdType text={getOrderStatusBadge(order)} />,
        },
        {
          item: (
            <TdType
              text={
                order.confirmedAt
                  ? moment(order.confirmedAt).format("DD-MM-YYYY HH:mm:ss")
                  : "-"
              }
              title={
                order.confirmedAt
                  ? moment(order.confirmedAt).format("DD-MM-YYYY HH:mm:ss")
                  : "-"
              }
            />
          ),
        },
        {
          item: (
            <TdType
              text={moment(order.statusUpdatedAt).format("DD-MM-YYYY HH:mm:ss")}
              title={moment(order.statusUpdatedAt).format(
                "DD-MM-YYYY HH:mm:ss"
              )}
            />
          ),
        },
        {
          item: <TdType text={numberFormatter(order.total)} />,
        },
        {
          item: (
            <TdType
              link={`/pedidos/${order.id}`}
              inputType="icon"
              icon={FaRegEdit}
              title="Ver pedido"
            />
          ),
        },
      ];
    });
    return formattedRows;
  };

  const createSkeleton = () => {
    let skeleton = [];
    for (let index = 0; index < 8; index++) {
      skeleton.push({ item: <Skeleton height="1rem" /> });
    }
    return skeleton;
  };

  return (
    <>
      <Box overflowX={"scroll"} pb={"0.5rem"}>
        <Table variant="striped" colorScheme="gray" fontSize="0.8em">
          <Thead>
            <Tr>
              <Th fontSize="0.8em"></Th>
              <Th fontSize="0.8em">#</Th>
              <Th fontSize="0.8em">Cliente</Th>
              <Th fontSize="0.8em"> Estado </Th>
              <Th fontSize="0.8em"> Confirmación </Th>
              <Th fontSize="0.8em"> Últ. estado </Th>
              <Th fontSize="0.8em">Total ($)</Th>
              <Th fontSize="0.8em" textAlign="center">
                Acciones
              </Th>
            </Tr>
          </Thead>
          {isLoadingOrders ? (
            <CustomTBody rows={[createSkeleton()]} />
          ) : orders.length ? (
            <CustomTBody rows={createRows()} />
          ) : (
            <Tbody>
              <Tr>
                <Td colSpan="100%">
                  <Box padding="1rem 0">No se encontraron resultados</Box>
                </Td>
              </Tr>
            </Tbody>
          )}
        </Table>
      </Box>
      <Flex justifyContent={"center"} py={"2rem"}>
        <Pagination
          max={maxPagination}
          currentPage={currentPage}
          handleSelectedPage={handleSelectedPage}
        />
      </Flex>
    </>
  );
};

export default OrdersTable;
